
import { db } from "@/firebase";
import { WorkingHour } from "@/model/entities";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
  writeBatch,
} from "firebase/firestore";


export const workingHoursService = {

  fetchByRestaurantId: async (restaurantId: string): Promise<WorkingHour[]> => {
    const workingHoursRef = collection(db, "workingHours");
    const restaurantWorkingHoursQuery = query(
      workingHoursRef,
      where("restaurantId", "==", restaurantId)
    );
    const snapshot = await getDocs(restaurantWorkingHoursQuery);
    return snapshot.docs.map(
      (doc) => ({ id: doc.id, ...doc.data() } as WorkingHour)
    );
  },

  add: async (
    restaurantId: string,
    workingHours: WorkingHour[]
  ): Promise<void> => {
    const workingHoursCollection = collection(db, "workingHours");
    const q = query(
      workingHoursCollection,
      where("restaurantId", "==", restaurantId)
    );
    const existingDocsSnapshot = await getDocs(q);
    const batch = writeBatch(db);
    existingDocsSnapshot.forEach((docSnap) => {
      batch.delete(docSnap.ref);
    });
    workingHours.forEach((hour) => {
      const docRef = doc(workingHoursCollection);
      batch.set(docRef, { ...hour, restaurantId } as WorkingHour);
    });
    await batch.commit();
  },

  delete: async (id: string): Promise<void> => {
    const workingHoursRef = doc(db, "workingHours", id);
    await deleteDoc(workingHoursRef);
  },

  deleteByRestaurantId: async (restaurantId: string): Promise<void> => {
    const workingHoursRef = collection(db, "workingHours");
    const q = query(workingHoursRef, where("restaurantId", "==", restaurantId));
    const snapshot = await getDocs(q);
    const batch = writeBatch(db);
    snapshot.docs.forEach((doc) => {
      batch.delete(doc.ref);
    });
    await batch.commit();
  },

  isOpen: (workingHours: WorkingHour[], date: Date): boolean => {
    const dayOfWeek = date.getDay().toString();
    const todayHours = workingHours.find((wh) => wh.day === dayOfWeek);
    if (!todayHours || todayHours.isVacation) {
      return false;
    }
    const openTime = new Date(date);
    const closeTime = new Date(date);
    const [openHour, openMinute] = todayHours.open.split(":").map(Number);
    const [closeHour, closeMinute] = todayHours.close.split(":").map(Number);
    
    openTime.setHours(openHour, openMinute, 0, 0);
    closeTime.setHours(closeHour, closeMinute, 0, 0);

    return date >= openTime && date < closeTime;
  }
};
